export default __webpack_public_path__ + "static/media/wow.0fca494f.svg";